import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React, { useContext } from "react";
import LanguageContext from "../../LanguageContext";

export default function Profit(props) {
  const classes = props.classes;
  const language = useContext(LanguageContext);
  return (
    <div className={classes.whatYouGetContainer}>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        className={classes.whatYouGetContent}
      >
        <Grid item xs={1} md={1} lg={1}></Grid>

        <Grid item xs={10} md={10} lg={10} className={classes.whatYouGetText}>
          <Typography variant={"body1"} align={"center"}>
            <b>{props.title}</b>
            {props.text}
          </Typography>
        </Grid>
        <Grid item xs={1} md={1} lg={1}></Grid>
      </Grid>

      <Grid container direction="row" justifyContent="center" alignItems="center">
        <Grid item>
          <img src={props.image} alt="" width="100%" height="100%" />
        </Grid>
      </Grid>
    </div>
  );
}
